import * as signalR from '@microsoft/signalr';
import store from "@/store/index";

const SignalRService = { 
	data: [], 
    connection: null , 
    heartbeatInterval: null,
    heartbeatTimeout: null,
    isReconnecting: false,
	}
const url = process.env.VUE_APP_API_BASE_URL + "/ServerHub"
// 心跳配置
const HEARTBEAT_CONFIG = {
    intervalMs: 9000,      // 每10秒发送一次心跳
    timeoutMs: 30000,       // 30秒未收到心跳确认则认为连接失效
    maxRetries: 10          // 最大重连次数
}


SignalRService.start = async function () {
    try {
        SignalRService.connection = new signalR.HubConnectionBuilder()
            .withUrl(url, {
                accessTokenFactory: () => store.state.user.refreshToken,
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
            })
            .configureLogging(signalR.LogLevel.None)   
			// .withAutomaticReconnect({  // 添加自动重连配置
			//         nextRetryDelayInMilliseconds: retryContext => {
			//             if (retryContext.previousRetryCount >= HEARTBEAT_CONFIG.maxRetries) {
			//                 return null; // 停止重连
			//             }
			//             // 指数退避：1s, 2s, 5s, 10s, 20s...
			//             const delay = Math.min(30000, Math.pow(2, retryContext.previousRetryCount) * 1000);
			//             return delay;
			//         }
			// })
            .build()
        // 处理连接状态变化
        // this.connection.onclose(async () => {
        //      await this.start();
        // });

        // 监听服务器发送的消息
        SignalRService.connection.on('ConnectResponse', (data) => {
            SignalRService.data = data
			//console.log(JSON.stringify(data));
            if (window.getIsOnLine) {
                window.getIsOnLine()   //调用全局方法
            }
            //console.log('收到消息:', data);

        })
		
		 // 监听连接关闭事件
		//   SignalRService.connection.onclose(async (error) => {
		//       console.log('SignalR 连接关闭:', error);
		//       SignalRService.stopHeartbeat(); // 停止心跳
		//       if (!SignalRService.isReconnecting) {
		//           SignalRService.isReconnecting = true;
		//           // 延迟5秒后尝试重连
		//           setTimeout(() => {
		//               SignalRService.start();
		//           }, 5000);
		//       }
		//   });
		
		//   // 监听重新连接事件
		//   SignalRService.connection.onreconnecting((error) => {
		//       console.log('SignalR 正在重连...', error);
		//       SignalRService.stopHeartbeat();
		//   });
		
		//   SignalRService.connection.onreconnected((connectionId) => {
		//       console.log('SignalR 重连成功, ConnectionId:', connectionId);
		//       SignalRService.startHeartbeat(); // 重连成功后重新启动心跳
		//       SignalRService.isReconnecting = false;
		//   });
		
		// // 监听服务器心跳确认
		// SignalRService.connection.on('HeartbeatAck', (serverTime) => {
		//     console.log('收到心跳确认:', serverTime);
		//     SignalRService.resetHeartbeatTimeout();
		// });
				
        await SignalRService.connection.start()
        //console.log('signalR连接');
		
		 // 启动心跳
		 //SignalRService.startHeartbeat();
		 //SignalRService.isReconnecting = false;

    } catch (err) {
        console.error('启动连接时出错:', err);
        // setTimeout(() => this.start(), 5000);
		 console.error('启动连接时出错:', err);
		 // SignalRService.isReconnecting = false;
		 // 延迟重试
		// setTimeout(() => SignalRService.start(), 5000);
    }

}
SignalRService.leaveGroup = async function () {
    try {
        if (SignalRService.connection) {
            await SignalRService.connection.stop();
            SignalRService.connection = null
        }
    } catch (err) {
        console.error('断开连接时出错:', err)
    }
}

// // ============= 心跳相关方法 =============

// /**
//  * 启动心跳检测
//  */
// SignalRService.startHeartbeat = function () {
//     if (!SignalRService.connection || SignalRService.connection.state !== signalR.HubConnectionState.Connected) {
//         console.warn('连接未就绪，无法启动心跳');
//         return;
//     }
    
//     // 停止现有的心跳
//     SignalRService.stopHeartbeat();
    
//     console.log('启动心跳检测，间隔:', HEARTBEAT_CONFIG.intervalMs, 'ms');
    
//     // 定时发送心跳
//     SignalRService.heartbeatInterval = setInterval(() => {
//         SignalRService.sendHeartbeat();
//     }, HEARTBEAT_CONFIG.intervalMs);
    
//     // 设置心跳超时检测
//     SignalRService.setupHeartbeatTimeout();
// }

// /**
//  * 发送心跳包
//  */
// SignalRService.sendHeartbeat = async function () {
//     if (!SignalRService.connection) {
//         return;
//     }
    
//     const state = SignalRService.connection.state;
//     if (state === signalR.HubConnectionState.Connected) {
//         try {
//             await SignalRService.connection.invoke("Heartbeat");
//             console.log('心跳已发送');
//         } catch (err) {
//             console.error('发送心跳失败:', err);
//             // 发送失败，可能连接已断开
//             SignalRService.handleHeartbeatFailure();
//         }
//     } else if (state === signalR.HubConnectionState.Reconnecting) {
//         console.log('连接正在重连中，跳过心跳');
//     } else {
//         console.warn('连接状态异常，停止心跳:', state);
//         SignalRService.stopHeartbeat();
//     }
// }

// /**
//  * 设置心跳超时检测
//  */
// SignalRService.setupHeartbeatTimeout = function () {
//     if (SignalRService.heartbeatTimeout) {
//         clearTimeout(SignalRService.heartbeatTimeout);
//     }
    
//     SignalRService.heartbeatTimeout = setTimeout(() => {
//         console.error('心跳超时，连接可能已失效');
//         SignalRService.handleHeartbeatTimeout();
//     }, HEARTBEAT_CONFIG.timeoutMs);
// }

// /**
//  * 重置心跳超时（收到服务器确认时调用）
//  */
// SignalRService.resetHeartbeatTimeout = function () {
//     if (SignalRService.heartbeatTimeout) {
//         clearTimeout(SignalRService.heartbeatTimeout);
//     }
//     SignalRService.setupHeartbeatTimeout();
// }

// /**
//  * 处理心跳失败
//  */
// SignalRService.handleHeartbeatFailure = function () {
//     if (!SignalRService.connection) return;
    
//     const state = SignalRService.connection.state;
//     if (state === signalR.HubConnectionState.Connected) {
//         // 尝试主动重连
//         console.log('心跳失败，尝试主动重连');
//         SignalRService.connection.stop().then(() => {
//             setTimeout(() => SignalRService.start(), 1000);
//         });
//     }
// }

// /**
//  * 处理心跳超时
//  */
// SignalRService.handleHeartbeatTimeout = function () {
//     console.error('心跳超时，执行重连');
//     SignalRService.stopHeartbeat();
    
//     if (SignalRService.connection && SignalRService.connection.state === signalR.HubConnectionState.Connected) {
//         SignalRService.connection.stop().then(() => {
//             SignalRService.start();
//         });
//     }
// }

// /**
//  * 停止心跳检测
//  */
// SignalRService.stopHeartbeat = function () {
//     if (SignalRService.heartbeatInterval) {
//         clearInterval(SignalRService.heartbeatInterval);
//         SignalRService.heartbeatInterval = null;
//     }
//     if (SignalRService.heartbeatTimeout) {
//         clearTimeout(SignalRService.heartbeatTimeout);
//         SignalRService.heartbeatTimeout = null;
//     }
//     console.log('心跳检测已停止');
// }

export default SignalRService